// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ragEntity from './entities/rag.json';
import ragMenu from '../pages/rag/menu.json';
import ragFullForm from '../pages/rag/forms/full.json';
import ragContextForm from '../pages/rag/forms/context.json';
import ragMiniForm from '../pages/rag/forms/mini.json';
import ragLookupForm from '../pages/rag/forms/lookup.json';
import ragTableView from '../pages/rag/views/table.json';
import ragStagesView from '../pages/rag/views/stages.json';
import ragCardsView from '../pages/rag/views/cards.json';
import ragInlineView from '../pages/rag/views/inline.json';
import ragBacklogView from '../pages/rag/views/backlog.json';
import ragSplitView from '../pages/rag/views/split.json';
import ragCalendarView from '../pages/rag/views/calendar.json';
import ragDashboardView from '../pages/rag/views/dashboard.json';

/** Тип запису «Факт» зі сторінками пакета: меню, форми та подання з pages/rag/. */
export const ragDefinition: IRecordTypeDefinition = {
  ...ragEntity,
  views: assembleViewSet({
      table: ragTableView,
      stages: ragStagesView,
      cards: ragCardsView,
      inline: ragInlineView,
      backlog: ragBacklogView,
      split: ragSplitView,
      calendar: ragCalendarView,
      dashboard: ragDashboardView,
  }),
  form: ragFullForm,
  forms: { full: ragFullForm, context: ragContextForm, mini: ragMiniForm, lookup: ragLookupForm },
  menu: ragMenu,
} as IRecordTypeDefinition;
